import { useEffect } from "react";
import Lenis from "lenis";
import Header from "@/components/landing/layout/Header";
import Footer from "@/components/landing/layout/Footer";
import { useGSAP } from "@/hooks/useGSAP";

import HowItWorks from "../components/HowItWorks";
import FAQSection from "../components/FAQSection";
import HeroSection from "../components/HeroSection";
import BrandSection from "../components/BrandSection";
import ValueSection from "../components/ValueSection";
import HowToBuy from "../components/HowToBuy";
import AccidentalProtection from "../components/AccidentalProtection";
import NotCovered from "../components/NotCovered";

const ewFaqData = [
  {
    question: "What does this Plan cover?",
    answer: "This Plan covers accidental physical damage caused by sudden and unforeseen events such as drops, impacts, or liquid spills that result in functional impairment.",
  },
  {
    question: "Why should I add an Protega Product Protection?",
    answer: "Protega provides coverage for accidental damage not covered by our manufacturer’s warranty starting on day one. After your manufacturer warranty expires, you’re still covered in case of Rips & Tears for the remainder of your Protega coverage term."
  },
  {
    question: "What happens if I return my product?",
    answer: "If you return your product, Adivaa returns the amount you paid for your product protection. Depending on how much time has passed since your purchase, you may receive a prorated refund, less any paid service."
  },
  {
    question: "Does this Plan cover manufacturing defects?",
    answer: "No. Manufacturing defects are covered under the manufacturer’s warranty."
  },
];

export default function AdivaaAccidental() {
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const lenis = new Lenis({
      duration: 1.6,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      smoothWheel: true,
      touchMultiplier: 2,
    });

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    const handleBeforeUnload = () => {
      sessionStorage.setItem("scrollY", String(window.scrollY));
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    // 👇 Check if it's a reload (type === 'reload')
    const navEntries = performance.getEntriesByType(
      "navigation"
    ) as PerformanceNavigationTiming[];
    const isReload = navEntries.length > 0 && navEntries[0].type === "reload";

    if (isReload) {
      const savedScrollY = sessionStorage.getItem("scrollY");
      if (savedScrollY !== null) {
        setTimeout(() => {
          window.scrollTo(0, parseFloat(savedScrollY));
        }, 100); // Wait for Lenis and DOM layout
      }
    }

    return () => {
      lenis.destroy();
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useGSAP();

  return (
    <div className="tw-min-h-screen tw-bg-white tw-text-black">
      <Header />
      <main className="tw-relative">
        <div className="tw-h-20 lg:tw-h-24" />

        {/* hero section */}
        <HeroSection />

        {/* brand section */}
        <BrandSection />

        {/* accidental protection section */}
        <AccidentalProtection />

        {/* value section */}
        <ValueSection />

        {/* how it works */}
        <HowItWorks />

        {/* not covered */}
        <NotCovered />

        {/* how to buy */}
        <HowToBuy />

        {/* faq section */}
        <FAQSection data={ewFaqData} link="/adivaa/accidental/tnc" />

        {/* footer */}
        <Footer />
      </main>
    </div>
  );
}
